"use client";

import type { FC, Ref } from "react";
import {
  TableCard,
  type TableCardProps,
} from "@huub-web/ui/components/TableCard";
import type { TableDataWithStyling } from "@huub-web/ui/types/TableData";
import { isNumber, isObject } from "@huub-web/utils";

type TableCardTemplatePropsType = Pick<
  TableCardProps,
  "data" | "type" | "title" | "value"
> & {
  //
};

export interface TableCardTemplateProps extends TableCardTemplatePropsType {}

/**
 * A template for a table card.
 * @deprecated 💀
 */
export const TableCardTemplate: FC<
  TableCardTemplateProps & { ref?: Ref<HTMLDivElement> }
> = ({ data, ref, ...props }) => {
  const parsedData = ((): TableDataWithStyling => {
    const { rows, headings } = data;

    const updatedHeadings = headings?.map((heading, colIndex) => {
      const allNumbers = rows?.every((row) => {
        const value = row?.values?.[colIndex].value;

        return (
          isNumber(value) ||
          (isObject(value) &&
            (value.type === "money" ||
              value.type === "percentage" ||
              value.type === "number"))
        );
      });

      return allNumbers ? { ...heading, align: "right" } : heading;
    });

    return { rows, headings: updatedHeadings } as TableDataWithStyling;
  })();

  return <TableCard ref={ref} data={parsedData} {...props} />;
};
